import { Injectable } from "@angular/core";
import { AppService } from "../../../core/services/app.service";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { tap } from "rxjs/internal/operators";
import { CacheService } from "../../../shared/services/cache.service";

@Injectable({
  providedIn: "root",
})
export class DigitalMemoryLogService {

  digitalMemoryApi = AppService.getApiUrl() + "/api/digitalMemoryLogs";
  needForceGetMyGroup = true;
  emailLogApi = AppService.getApiUrl() + "/api/emailLogs/filter_default";
  constructor(public http: HttpClient, private cacheService: CacheService) {}

  getMyDigitalMemoryLogs(shipId, search = "", status = null, force = false, skip = 0, limit = 10) {
    let queryParams = "?filter=";
    const filter = {
      where: {
        shipId: { eq: shipId },
        ...(search ? { name: { like: `%${search}%` } } : {}),
      },
      order: 'createdAt desc',
      skip: skip,
      limit: limit
    }
        

    queryParams = queryParams + encodeURIComponent(JSON.stringify(filter));

    // Create a unique cache key that includes pagination parameters
    const cacheKey = `digital-memory-logs-${shipId}-${search}-${skip}-${limit}`;

    const request = this.cacheService.cacheRequest(
      cacheKey,
      this.http.get(this.digitalMemoryApi + "/filter_default" + queryParams).pipe(
        tap((res: any) => {
          if (this.needForceGetMyGroup) {
            this.needForceGetMyGroup = true;
          }
        })
      ),
      this.needForceGetMyGroup
    );
    return request.getResult();
  }

  getShipList(force = false) {
    const apiUrl = this.digitalMemoryApi + "/shipList";
    const cacheKey = "ship-list";

    const request = this.cacheService.cacheRequest(
      cacheKey,
      this.http.get(apiUrl).pipe(map((res: any) => res.Data || res)),
      force
    );

    return request.getResult();
  }

  getShipById(shipId: string) {
    const apiUrl = AppService.getApiUrl() + "/api/digitalMemoryLog" ;
    return this.http.get(apiUrl).pipe(map((res: any) => res.Data || res));
  }

  getPreviewById(id: string) {
    const apiUrl = this.digitalMemoryApi + "/preview/" + id;
    return this.http.get(apiUrl).pipe(map((res: any) => res.Data || res));
  }

  duplicateDigitalMemoryLog(id: number) {
    return this.http.post(this.digitalMemoryApi + "/duplicate", { id });
  }

  getEmailLogs( search = "", fromDate = null, toDate = null, digitalLogId = null, skip = 0, limit = 10) {
    const filter: any = {
      where: {
        ...(digitalLogId ? { digitalMemoryLogId: { eq: digitalLogId } } : {}),
        ...(fromDate && toDate ? { createdAt: { between: [fromDate, toDate] } } : {})
      },
      order: 'createdAt desc',
      skip: skip,
      limit: limit
    };

    // Add search filter if search term is provided
    if (search && search.trim()) {
      filter.where.or = [
        { email: { like: `%${search}%` } },
        { firstName: { like: `%${search}%` } },
        { lastName: { like: `%${search}%` } },
        { recipientName: { like: `%${search}%` } }
      ];
    }

    const apiUrl = this.emailLogApi + "?filter=" + encodeURIComponent(JSON.stringify(filter));
    return this.http.get(apiUrl).pipe(map((res: any) => res.Data || res));
  }

  createDigitalMemoryDraft(shipId) {
    return this.http.post(this.digitalMemoryApi + "/draft", { shipId: shipId });
  }
}
